import * as React from 'react';

import { IChat } from '../../../types/chatList';
import { TMessagesMap } from '../../../utils/messageUtils';

const MAX_COUNT_CLOSED_CHATS_FOR_UXFB = 1;

export const useChatsWithTodayMessage = (
  chats: IChat[],
  messagesMap: TMessagesMap,
  countClosedChats: number,
  isEventUXFBSended: boolean,
  isSendUXFBMonitoringEnabled: boolean,
) => {
  const isNeededCallUXFB = React.useMemo(() => {
    const chatsNotBot = chats.filter(chat => chat.type !== 'bot');
    if (
      chatsNotBot.length < 2 ||
      countClosedChats < MAX_COUNT_CLOSED_CHATS_FOR_UXFB ||
      isEventUXFBSended ||
      !isSendUXFBMonitoringEnabled
    ) {
      return false;
    }

    const today = new Date();

    const countChatsWithTodayMessage = chatsNotBot
      .map(chat => {
        const lastMessageDate = chat.lastMessage?.created ? new Date(chat.lastMessage?.created) : null;
        if (
          lastMessageDate &&
          lastMessageDate.getDate() === today.getDate() &&
          lastMessageDate.getMonth() === today.getMonth() &&
          lastMessageDate.getFullYear() === today.getFullYear()
        ) {
          return true;
        }

        return false;
      })
      .filter(Boolean).length;

    if (countChatsWithTodayMessage > 1) {
      return true;
    }

    const chatIds = [];
    let messageIndex = 0;
    const messagesMapKeys = [...messagesMap.keys()];

    while (chatIds.length < 2 && messageIndex < messagesMapKeys.length) {
      const messageId = messagesMapKeys[messageIndex];
      const message = messagesMap.get(messageId);
      const chatId = message?.message.chatId;

      if (message) {
        const lastMessageDate = message.message.message.created ? new Date(message.message.message.created) : null;

        if (
          lastMessageDate &&
          lastMessageDate.getDate() === today.getDate() &&
          lastMessageDate.getMonth() === today.getMonth() &&
          lastMessageDate.getFullYear() === today.getFullYear()
        ) {
          if (chatIds.indexOf(chatId) === -1) {
            chatIds.push(chatId);
          }
        }
      }

      messageIndex++;
    }

    return countChatsWithTodayMessage > 2;
  }, [chats, countClosedChats, isEventUXFBSended, isSendUXFBMonitoringEnabled, messagesMap]);

  return isNeededCallUXFB;
};
